import React from 'react';
import styled from 'styled-components';
import { IconWrapper, SvgIcon } from '../../../../components/Icon';
import { ReactComponent as PublishedIndicator } from '../../../../assets/images/published-indicator.svg';
import { theme } from '../../../../styles/theme';

interface IProps {
  pathName: string | null;
  onGoBack?: () => void;
}

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 8px;
  padding: 10px 12px 8px;
`;
const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
  color: ${theme.colors.secondary900};
`;

const DashboardFolderWidgetHeader = ({ pathName, onGoBack }: IProps) => {
  return (
    <Container>
      <IconWrapper size={16} onClick={onGoBack}>
        {onGoBack ? (
          <SvgIcon
            name="arrow-left-bold"
            width={14}
            height={14}
            customFill="currentColor"
          />
        ) : (
          <PublishedIndicator width={16} height={16} />
        )}
      </IconWrapper>
      <Title>{pathName || 'Published Dashboards'}</Title>
    </Container>
  );
};

export default DashboardFolderWidgetHeader;
